import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Calendar, CalendarSearchParams} from '@accounting/_common/models/calendar.models';

export const CheckState = createAction(
    '[Calendars] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Calendar[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Calendars] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Calendar[] } }>()
);

export const LoadList = createAction(
    '[Calendars] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Calendars] Load List Success',
    props<{ payload: { items: Calendar[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Calendars] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Calendars] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Calendars] Set Filter',
    props<{ payload: CalendarSearchParams }>()
);

export const SetLoading = createAction(
    '[Calendars] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Calendars] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Calendars] Update Item Success',
    props<{ payload: Calendar }>()
);

export const DeleteItem = createAction(
    '[Calendars] Delete Item',
    props<{ payload: Calendar }>()
);

export const DeleteItemSuccess = createAction(
    '[Calendars] Delete Item Success',
    props<{ payload: Calendar }>()
);

export const DeleteItemFailure = createAction(
    '[Calendars] Delete Item Failure',
    props<{ payload: Calendar }>()
);

export const SetInitialState = createAction(
    '[Calendars] Set Initial State'
);

export const UpdateCalendarItem = createAction(
    '[Calendars] Update Calendars Item',
    props<{ payload: Calendar }>()
);
